export const sendYMetrik = (type, value) => {
    window.ym(81866044, type, value);
}

export const sendGAnalytic = (pageParams) => {
    const gtag = window.gtag,
          {page_title = '', page_location = '', page_path = ''} = pageParams

    if (typeof(gtag) === 'function') {

        gtag('config', 'G-K0MKQJCP8J', {
            'page_title': page_title,
            'page_location': page_location,
            'page_path': page_path
        });
    }

}

export const sendToAnalytics = (componentPath) => {

    /**
     * componentPath - /landing/n/componentName 
     */

    const hasClickId = localStorage.getItem('click_id'),
          componentName = `${componentPath}`.replace(/\/landing\/\d+/, '')


    let fullHost = `${window.location.protocol}//${window.location.host}`,
        page_location = `${fullHost}${componentPath}`,
        page_path = componentName

    if (window.location.href.includes('?')) {
        page_location = window.location.href.replace('?', '/' + componentPath + '/?')
    }
    
    if (hasClickId) {
        const GETParametersString = localStorage.getItem('GET-parameters-string')
        page_location = `${page_location}${GETParametersString}`
    }
    
    sendGAnalytic({
        page_title: page_path,
        page_location,
        page_path
    })
    sendYMetrik('hit', componentName)
}